import { createStore } from 'vuex'
import notification from './modules/notification'
import ui from './modules/ui'
import email from './modules/email'
import assignments from './modules/assignments'
import actions from './modules/actions'
import lookup from './modules/lookup'
import auth from './modules/auth'
import office from './modules/office'

export default createStore({
  modules: {
    notification,
    ui,
    email,
    assignments,
    actions,
    lookup,
    auth,
    office
  },
  state: {
    // Global state that doesn't belong to specific modules
    appVersion: '1.0.0',
    isOfficeReady: false,
    selectedTab: 'Actions',
    notifications: 2,
    selectedEmail: {
      subject: 'Request for Commercial Property Appraisal - Downtown Office Building',
      sender: 'Michael Thompson <michael.thompson@acmecorp.com>',
      received: 'Today, 9:31 PM'
    },
    assignment: null,
    quickActionMessage: '',
    additionalActionsOpen: false
  },
  mutations: {
    SET_OFFICE_READY(state, isReady) {
      state.isOfficeReady = isReady
    },
    setTab(state, tab) {
      state.selectedTab = tab
    },
    setAssignment(state, assignment) {
      state.assignment = assignment
    },
    setQuickActionMessage(state, msg) {
      state.quickActionMessage = msg
    },
    setAdditionalActionsOpen(state, open) {
      state.additionalActionsOpen = open
    }
  },
  actions: {
    initializeApp({ commit }) {
      Office.onReady(() => {
        commit('SET_OFFICE_READY', true)
      })
    },
    selectTab({ commit }, tab) {
      commit('setTab', tab)
    },
    selectAssignment({ commit }) {
      commit('setAssignment', 'Downtown Office Building')
    },
    doQuickAction({ commit }, action) {
      commit('setQuickActionMessage', `Action performed: ${action}`)
      setTimeout(() => commit('setQuickActionMessage', ''), 2000)
    },
    toggleAdditionalActions({ commit, state }) {
      commit('setAdditionalActionsOpen', !state.additionalActionsOpen)
    }
  },
  getters: {
    isOfficeReady: state => state.isOfficeReady
  }
})